import { load } from "cheerio";

export const stripAttributesFromHTMLString = (htmlString: string, attributesToRemove: string[]) => {
  if (!htmlString) return;

  const cheerio = load(htmlString, null, false);

  cheerio("*").each((_index, element) => {
    Object.keys(("attribs" in element && element.attribs) || {}).forEach(attribute => {
      if (attributesToRemove.includes(attribute)) {
        cheerio(element).removeAttr(attribute);
      }
    });
  });

  return cheerio.html();
};
